<template>
  <div
      class="modal"
      tabindex="-1"
      role="dialog"
      v-bind:id="'route_merge_modal_' + routeRP.id"
      data-bs-backdrop="false"
      data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Route {{ routeRP.name }} samenvoegen</h5>

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="text-muted text-center fst-italic" v-if="numRouteCoords === 0">
            Een route zonder punten kan niet samengevoegd worden.
          </div>
          <div class="text-muted text-center fst-italic" v-else-if="suggestions.length === 0">
            Er zijn geen andere routes om mee samen te voegen.
          </div>

          <div v-if="suggestions.length > 0">
            <div class="form-group">
              <label class="form-label" v-if="otherRoutes.length > 1">Suggesties</label>
              <div class="card mb-2" v-for="routeOption in suggestions">
                <label class="card-body" v-bind:for="'rmm_' + routeOption.key + '-suggestion'">
                  <input
                      class="form-check-input"
                      type="radio"
                      v-bind:name="'mergeRoute' + route.id"
                      v-bind:id="'rmm_' + routeOption.key + '-suggestion'"
                      v-bind:value="routeOption.id1 + ',' + routeOption.id2 + ',suggestion'"
                      v-model="selectedMerge"
                  >
                  <span class="ms-2" v-bind:style="{borderBottom: '2px solid ' + routeOption.color1}">
                    {{ routeOption.name1 }}
                  </span>
                  <span class="ms-2 text-secondary small">o</span>
                  <span class="ms-1 distance-text text-secondary border-secondary-subtle" v-bind:style="{borderBottomWidth: '2px', borderBottomStyle: 'dashed'}">
                    {{ routeOption.distanceFormatted }}
                  </span>
                  <span class="ms-1 text-secondary small">o</span>
                  <span class="ms-2" v-bind:style="{borderBottom: '2px solid ' + routeOption.color2}">
                    {{ routeOption.name2 }}
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group" v-if="otherRoutes.length > 1">
            <label v-bind:for="'rmm_' + routeRP.id + '_route'" class="form-label">Routes</label>
            <select class="form-select" v-bind:id="'rmm_' + routeRP.id + '_route'" v-model="selectedRouteId">
              <option v-for="route in otherRoutes" v-bind:value="route.id">{{ route.name }}</option>
            </select>
          </div>

          <div class="form-group" v-if="otherRoutes.length > 1">
            <div class="row" v-for="otherRouteOptions in routeOptions.filter(ro => ro[0].id1 === selectedRouteId || ro[1].id1 === selectedRouteId)">
              <div class="col-lg-6" v-for="routeOption in otherRouteOptions" :key="routeOption.key">
                <div class="card mb-2">
                  <label class="card-body" v-bind:for="'rmm_' + routeOption.key">
                    <input
                        class="form-check-input"
                        type="radio"
                        v-bind:name="'mergeRoute' + route.id"
                        v-bind:id="'rmm_' + routeOption.key"
                        v-bind:value="routeOption.id1 + ',' + routeOption.id2"
                        v-model="selectedMerge"
                    >
                    <span class="ms-2" v-bind:style="{borderBottom: '2px solid ' + routeOption.color1}">
                      {{ routeOption.name1 }}
                    </span>
                    <span class="ms-2 text-secondary small">o</span>
                    <span class="ms-1 distance-text text-secondary border-secondary-subtle" v-bind:style="{borderBottomWidth: '2px', borderBottomStyle: 'dashed'}">
                      {{ routeOption.distanceFormatted }}
                    </span>
                    <span class="ms-1 text-secondary small">o</span>
                    <span class="ms-2" v-bind:style="{borderBottom: '2px solid ' + routeOption.color2}">
                      {{ routeOption.name2 }}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="applyMerge" v-bind:disabled="!selectedMerge">Samenvoegen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Container from "../Main/Container";
import $ from "jquery";
import Route from "../Main/Route";
import {bsModal} from "../Util/vueFunctions";
import {getLength} from "ol/sphere.js";
import {LineString} from "ol/geom.js";
import RouteMergeAction from "../ActionHistory/RouteMergeAction.js";

export default {
  props: {
    listenId: String,
    route: Route,
  },
  data () {
    $(() => {
      const route = this.route;

      $('#' + this.listenId).on('click', () => {
        this.computeRoutes(route);

        bsModal('#route_merge_modal_' + route.id).show();
      });
    });

    return {
      container: Container,
      routeRP: this.route.reactiveProps,
      numRouteCoords: null,
      routeOptions: [],
      suggestions: [],
      otherRoutes: [],
      selectedRouteId: null,
      selectedMerge: null,
    };
  },
  watch: {

  },
  computed: {

  },
  methods: {
    _computeDistance(route1: Route, route2: Route): number|null {
      const coords1 = route1.getCoordinates();
      const coords2 = route2.getCoordinates();
      if (coords1.length === 0 || coords2.length === 0) {
        return null;
      }

      const coord1 = coords1[coords1.length - 1];
      const coord2 = coords2[0];

      return getLength(new LineString([coord1, coord2]));
    },
    computeRoutes(route: Route) {
      const routeOptions = [];
      const distances = [];
      const otherRoutes = [];
      this.numRouteCoords = route.getCoordinates().length;

      for (const otherRoute of route.routeCollection.getRoutes()) {
        if (otherRoute.id === route.id) {
          continue;
        }

        const distance1 = this._computeDistance(otherRoute, route);
        const distance2 = this._computeDistance(route, otherRoute);

        if (distance1 === null || distance2 === null) {
          continue;
        }

        distances.push(distance1);
        distances.push(distance2);

        otherRoutes.push({
          'id': otherRoute.id,
          'name': otherRoute.name,
        });
        routeOptions.push([
          {
            key: otherRoute.id + '-before-' + route.id,
            id1: otherRoute.id,
            name1: otherRoute.getName(),
            color1: otherRoute.getColor(),
            id2: route.id,
            name2: route.getName(),
            color2: route.getColor(),
            distance: distance1,
            distanceFormatted: Route.formatLength(distance1),
          },
          {
            key: otherRoute.id + '-after-' + route.id,
            id1: route.id,
            name1: route.getName(),
            color1: route.getColor(),
            id2: otherRoute.id,
            name2: otherRoute.getName(),
            color2: otherRoute.getColor(),
            distance: distance2,
            distanceFormatted: Route.formatLength(distance2),
          }
        ]);
      }

      distances.sort((a, b) => a - b);

      const suggestions = [];
      if (distances.length > 0) {
        const threshold = distances[Math.min(distances.length - 1, 2)];
        for (const otherRouteOptions of routeOptions) {
          for (const routeOption of otherRouteOptions) {
            if (routeOption.distance <= threshold) {
              suggestions.push(routeOption);
            }
          }
        }
      }

      suggestions.sort((a, b) => a.distance - b.distance);

      this.suggestions = suggestions;
      this.routeOptions = routeOptions;
      this.otherRoutes = otherRoutes;
      this.selectedMerge = null;
      if (this.otherRoutes.length > 0) {
        this.selectedRouteId = this.otherRoutes[0].id;
      } else {
        this.selectedRouteId = null;
      }
      if (this.suggestions.length > 0) {
        this.selectedMerge = this.suggestions[0].id1 + ',' + this.suggestions[0].id2 + ',suggestion';
      }
    },
    applyMerge() {
      if (!this.selectedMerge) {
        return;
      }

      const ids = this.selectedMerge.split(',')

      const route1 = this.route.routeCollection.find(+ids[0]);
      const route2 = this.route.routeCollection.find(+ids[1]);

      if (!route1 || !route2) {
        return;
      }

      this.route.routeCollection.userInterface.actionHistory.addAction(new RouteMergeAction(route1, route2));

      bsModal('#route_merge_modal_' + this.route.id).hide();
    },
  }
};
</script>

<style scoped>
.distance-text {
  font-size: 8pt;
  vertical-align: top;
}
</style>
